"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyWithName = exports.RadioGroupWithName = exports.StackWithName = exports.ButtonWithName = exports.IconButtonWithName = exports.InputAdornmentWithName = exports.GridWithName = exports.FormLabelWithName = exports.FormHelperTextWithName = exports.FormGroupWithName = exports.FormControlLabelWithName = exports.FormControlWithName = exports.CollapseWithName = exports.BoxWithName = exports.withDisplayName = void 0;
const Box_1 = require("../box/Box");
const Collapse_1 = require("../collapse/Collapse");
const FormControl_1 = require("../formControl/FormControl");
const FormControlLabel_1 = require("../formControlLabel/FormControlLabel");
const FormGroup_1 = require("../formGroup/FormGroup");
const FormHelperText_1 = require("../formHelperText/FormHelperText");
const FormLabel_1 = require("../formLabel/FormLabel");
const Grid_1 = require("../grid/Grid");
const InputAdornment_1 = require("../inputAdornment/InputAdornment");
const IconButton_1 = require("../button/IconButton");
const Button_1 = require("../button/Button");
const Stack_1 = require("../stack/Stack");
const RadioGroup_1 = require("../radioGroup/RadioGroup");
const Typography_1 = require("../typography/Typography");
function withDisplayName(component, name) {
    Object.defineProperty(component, 'displayName', {
        value: name,
        writable: false,
        configurable: true,
    });
    return component;
}
exports.withDisplayName = withDisplayName;
const BoxWithName = withDisplayName(Box_1.Box, 'Box');
exports.BoxWithName = BoxWithName;
const CollapseWithName = withDisplayName(Collapse_1.Collapse, 'Collapse');
exports.CollapseWithName = CollapseWithName;
const FormControlWithName = withDisplayName(FormControl_1.FormControl, 'FormControl');
exports.FormControlWithName = FormControlWithName;
const FormControlLabelWithName = withDisplayName(FormControlLabel_1.FormControlLabel, 'FormControlLabel');
exports.FormControlLabelWithName = FormControlLabelWithName;
const FormGroupWithName = withDisplayName(FormGroup_1.FormGroup, 'FormGroup');
exports.FormGroupWithName = FormGroupWithName;
const FormHelperTextWithName = withDisplayName(FormHelperText_1.FormHelperText, 'FormHelperText');
exports.FormHelperTextWithName = FormHelperTextWithName;
const FormLabelWithName = withDisplayName(FormLabel_1.FormLabel, 'FormLabel');
exports.FormLabelWithName = FormLabelWithName;
const GridWithName = withDisplayName(Grid_1.Grid, 'Grid');
exports.GridWithName = GridWithName;
const InputAdornmentWithName = withDisplayName(InputAdornment_1.InputAdornment, 'InputAdornment');
exports.InputAdornmentWithName = InputAdornmentWithName;
const IconButtonWithName = withDisplayName(IconButton_1.IconButton, 'IconButton');
exports.IconButtonWithName = IconButtonWithName;
const ButtonWithName = withDisplayName(Button_1.Button, 'Button');
exports.ButtonWithName = ButtonWithName;
const StackWithName = withDisplayName(Stack_1.Stack, 'Stack');
exports.StackWithName = StackWithName;
const RadioGroupWithName = withDisplayName(RadioGroup_1.RadioGroup, 'RadioGroup');
exports.RadioGroupWithName = RadioGroupWithName;
const TypographyWithName = withDisplayName(Typography_1.Typography, 'Typography');
exports.TypographyWithName = TypographyWithName;
//# sourceMappingURL=CustomUtils.js.map